export function clearNonNumbers(value: string): string {
  return value ? value.match(/\d+/g).join('') : '';
}
